import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { apiClient } from '../api/client';
import { authApi } from '../api/services';
import type { UserInfo } from '../types/api.types';

interface AuthState {
  user: UserInfo | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
  login: (username: string, password: string) => Promise<boolean>;
  logout: () => void;
  checkAuth: () => Promise<void>;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      isAuthenticated: false,
      isLoading: false,
      error: null,

      login: async (username: string, _password: string) => {
        set({ isLoading: true, error: null });
        try {
          apiClient.setKeyId(username);
          const user = await authApi.getCurrentUser();
          set({ user, isAuthenticated: true, isLoading: false });
          return true;
        } catch (error) {
          apiClient.clearKeyId();
          set({
            user: null,
            isAuthenticated: false,
            isLoading: false,
            error: 'Anmeldung fehlgeschlagen. Bitte prüfen Sie Ihre Zugangsdaten.',
          });
          return false;
        }
      },

      logout: () => {
        apiClient.clearKeyId();
        set({ user: null, isAuthenticated: false, error: null });
      },

      checkAuth: async () => {
        set({ isLoading: true });
        try {
          const user = await authApi.getCurrentUser();
          set({ user, isAuthenticated: true, isLoading: false });
        } catch {
          set({ user: null, isAuthenticated: false, isLoading: false });
        }
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);
